<div
  *transloco="
    let t;
    scope: 'featureSearch';
    prefix: 'featureSearch.nlsOverviewAndFeedback'
  "
  class="bd-overview-container"
  [class.bd-overview-collapsed]="store.collapsed()"
  [@.disabled]="reduceMotion"
  data-id="nls-overview-and-feedback-component"
>
  <div class="bd-overview-header">
    <span
      data-id="nls-overview-title"
      class="bd-label-large flex items-center gap-[6px]"
    >
      <span class="ui-stars"></span>
      {{ t('title') }}</span
    >
    @if (store.collapsed() && appliedFilterCount() > 0) {
      @let filterCount = appliedFilterCount();
      <bd-badge
        data-id="nls-overview-filter-count"
        [label]="
          t('filterCount', {
            count: filterCount,
            pluralSuffix: filterCount === 1 ? '' : 's',
          })
        "
        type="info"
        [customIcon]="''"
      ></bd-badge>
    }
    <p-button
      data-id="nls-overview-collapse-toggle"
      styleClass="bd-neutral bd-size-small"
      [text]="true"
      [icon]="store.collapsed() ? 'ui-down' : 'ui-up'"
      [ariaLabel]="
        store.collapsed() ? t('expandOverview') : t('collapseOverview')
      "
      (onClick)="store.toggleCollapsed()"
    ></p-button>
  </div>
  @if (!store.collapsed()) {
    <div
      data-id="nls-overview-body"
      class="bd-overview-body"
      [@bdNlsOverviewBody]="''"
    >
      <div
        data-id="nls-overview-description"
        class="bd-body-regular flex flex-col gap-4"
      >
        <div class="flex flex-col">
          @for (line of overviewLines(); track $index) {
            @if (line.kind === 'markdown') {
              <quill-view-html
                data-id="nls-overview-line"
                class="bd-view-only bd-nls-overview-line"
                [content]="line.content | renderMarkdown"
                theme="snow"
                [sanitize]="true"
              ></quill-view-html>
            } @else {
              <span
                class="bd-nls-overview-line bd-nls-overview-line-interactive"
              >
                @for (segment of line.segments; track $index) {
                  @if (segment.kind === 'markdown') {
                    <quill-view-html
                      data-id="nls-overview-line-segment"
                      class="bd-view-only"
                      [content]="segment.content | renderMarkdown"
                      theme="snow"
                      [sanitize]="true"
                    ></quill-view-html>
                  } @else if (!editable()) {
                    <span
                      data-id="nls-overview-parameter-readonly"
                      class="bd-nls-parameter-readonly"
                    >
                      {{ segment.displayValue }}
                    </span>
                  } @else {
                    <bd-value-editor
                      dataIdPrefix="nls-overview-parameter"
                      [textInputLabel]="t('parameterValueInputLabel')"
                      [descriptor]="segment.descriptor"
                      [valueLabel]="{ text: segment.displayValue }"
                      [attributeCategoryDefinitions]="
                        attributeCategoryDefinitions()
                      "
                      (selectNode)="onSelectNode($event, segment)"
                      (attributeChange)="
                        onUpdateAttributeValue(
                          $event,
                          segment.parameter.parameterKey
                        )
                      "
                      (textChange)="
                        onUpdateSimpleValue(
                          $event,
                          segment.parameter.parameterKey
                        )
                      "
                    />
                  }
                }
              </span>
            }
          }
        </div>
        <p-divider [dt]="noMarginDividerDesignTokens"></p-divider>
      </div>
      <div data-id="nls-feedback-buttons" class="flex items-center gap-6">
        <div class="flex gap-4">
          @let positiveRated = store.feedbackScore() === 1;
          @let negativeRated = store.feedbackScore() === 0;
          <p-button
            [ariaLabel]="t('thumbsUp')"
            data-id="nls-feedback-positive-button"
            styleClass="bd-filter-tag"
            [outlined]="!positiveRated"
            [icon]="positiveRated ? 'ui-thumbs-up-solid' : 'ui-thumbs-up'"
            (onClick)="sendFeedback(true)"
          ></p-button>
          <p-button
            [ariaLabel]="t('thumbsDown')"
            data-id="nls-feedback-negative-button"
            styleClass="bd-filter-tag"
            [outlined]="!negativeRated"
            [icon]="negativeRated ? 'ui-thumbs-down-solid' : 'ui-thumbs-down'"
            (onClick)="sendFeedback(false)"
          ></p-button>
        </div>
        @if (coworkerAvailable()) {
          <p-button
            (onClick)="refineWithCoworkerClicked.emit()"
            data-id="nls-feedback-refine-with-coworker-button"
            styleClass="bd-filter-tag bd-clear-filter-tag"
            icon="ui-comment"
            [label]="t('refineWithCoworker')"
          ></p-button>
        }
        <p-button
          (onClick)="clearFilters()"
          data-id="nls-feedback-clear-filters-button"
          styleClass="bd-filter-tag bd-clear-filter-tag"
          [label]="t('clearFilters')"
        ></p-button>
      </div>
      @if (store.commentBoxOpen()) {
        <div
          *transloco="
            let tFeedback;
            scope: 'uiComponents';
            prefix: 'uiComponents.feedback'
          "
          class="bd-feedback-container"
          data-id="nls-feedback-container"
        >
          <span class="bd-body-regular">{{ tFeedback('feedbackTitle') }}</span>
          <div class="flex flex-col gap-2">
            <label for="nls-feedback-textarea" class="bd-label-small-gray">{{
              tFeedback('feedbackCommentInputLabel')
            }}</label>
            <textarea
              id="nls-feedback-textarea"
              pInputTextarea
              data-id="nls-feedback-textarea"
              class="bd-feedback-textarea"
              rows="3"
              cols="30"
              autoResize
              [ngModel]="store.feedbackComment()"
              (ngModelChange)="store.updateFeedbackComment($event)"
            ></textarea>
            <bd-helper-text
              [text]="t('feedbackCommentHelperText')"
              data-id="nls-feedback-comment-helper-text"
            ></bd-helper-text>
          </div>
          <p-button
            styleClass="bd-size-small"
            data-id="nls-feedback-submit-button"
            (onClick)="submitFeedbackComment()"
            [label]="t('submit')"
          ></p-button>
        </div>
      }
    </div>
  }
</div>
